var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifiAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 1.25C3.58579 1.25 3.25 1.58579 3.25 2C3.25 2.41421 3.58579 2.75 4 2.75C8.41582 2.75 12.8292 4.43399 16.1976 7.80241C19.1619 10.7667 20.8212 14.5396 21.1771 18.4112C21.2257 18.9396 21.25 19.4698 21.25 20C21.25 20.4142 21.5858 20.75 22 20.75C22.4142 20.75 22.75 20.4142 22.75 20C22.75 19.424 22.7236 18.848 22.6708 18.2739C22.2841 14.0663 20.4794 9.96287 17.2583 6.74175C13.5972 3.08073 8.79738 1.25 4 1.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0288 6.75964C3.61458 6.75964 3.2788 7.09542 3.2788 7.50964C3.2788 7.92385 3.61458 8.25964 4.0288 8.25964C7.0272 8.25964 10.0231 9.4029 12.3101 11.6899C14.5971 13.9769 15.7403 16.9728 15.7403 19.9712C15.7403 20.3854 16.0761 20.7212 16.4903 20.7212C16.9045 20.7212 17.2403 20.3854 17.2403 19.9712C17.2403 16.5912 15.9503 13.2088 13.3708 10.6292C10.7912 8.04964 7.40876 6.75964 4.0288 6.75964Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05759 12.2693C3.64338 12.2693 3.30759 12.6051 3.30759 13.0193C3.30759 13.4335 3.64338 13.7693 4.05759 13.7693C5.63858 13.7693 7.2171 14.3719 8.42262 15.5774C9.62813 16.7829 10.2307 18.3614 10.2307 19.9424C10.2307 20.3566 10.5665 20.6924 10.9807 20.6924C11.3949 20.6924 11.7307 20.3566 11.7307 19.9424C11.7307 17.9799 10.9814 16.0148 9.48328 14.5167C7.98516 13.0186 6.02014 12.2693 4.05759 12.2693Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.73223 21.2678C3.70854 22.2441 5.29146 22.2441 6.26777 21.2678C7.24408 20.2915 7.24408 18.7085 6.26777 17.7322C5.29146 16.7559 3.70854 16.7559 2.73223 17.7322C1.75592 18.7085 1.75592 20.2915 2.73223 21.2678Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiAlt);
export default __webpack_public_path__ + "static/media/wifi-alt.2ce4d0e0996b7fc0ae43d0b7cbdaeee7.svg";
export { ForwardRef as ReactComponent };